import { useEffect, useRef, useSyncExternalStore } from "react";

const handlers: (() => void)[] = [];
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((listener) => listener());
export function useLocalBackCount() {
  return useSyncExternalStore((listener) => { listeners.add(listener); return () => { listeners.delete(listener); }; }, () => handlers.length);
}
export function consumeLocalBack() {
  const handler = handlers.at(-1);
  if (!handler) return false;
  handler(); return true;
}
export function useLocalBack(active: boolean, callback: () => void) {
  const latest = useRef(callback); latest.current = callback;
  useEffect(() => {
    if (!active) return;
    const handler = () => latest.current();
    handlers.push(handler);
    emit();
    const escape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !event.defaultPrevented && handlers.at(-1) === handler) { event.preventDefault(); handler(); }
    };
    document.addEventListener("keydown", escape);
    return () => { document.removeEventListener("keydown", escape); const index = handlers.indexOf(handler); if (index >= 0) handlers.splice(index, 1); emit(); };
  }, [active]);
}
